module.exports = __webpack_public_path__ + "img/horizontal_7_7_8004.3cc14e1e.png";